
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2z7nN", function(module, exports) {
$parcel$export(module.exports, "FormLoading", function () { return (parcelRequire("fPivo")).FormLoading; });
$parcel$export(module.exports, "SignupForm", function () { return (parcelRequire("ddN1B")).SignupForm; });
$parcel$export(module.exports, "SignupFormSuccessUFOEvent", function () { return (parcelRequire("9ax0J")).SignupFormSuccessUFOEvent; });
$parcel$export(module.exports, "SiteNameForm", function () { return (parcelRequire("2oRUX")).SiteNameForm; });
parcelRequire("5OjGY");
parcelRequire("jQIyh");
parcelRequire("aHxuL");

});
parcelRegister("5OjGY", function(module, exports) {
$parcel$export(module.exports, "FormLoading", function () { return (parcelRequire("fPivo")).FormLoading; });
parcelRequire("fPivo");

});
parcelRegister("fPivo", function(module, exports) {

$parcel$export(module.exports, "FormLoading", function () { return $8116958daecdf4bd$export$2f1709634d27333b; });
/* form-loading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $9gh2a = parcelRequire("9gh2a");
const $8116958daecdf4bd$export$2f1709634d27333b = ({ notFullHeight: notFullHeight = false })=>{
    const intl = (0, $f6qj2.default)();
    const loading = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.loading",
        defaultMessage: "Loading"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        role: "progressbar",
        "aria-label": loading,
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o",
            !notFullHeight && "_4t3i1kxc"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
            size: "large"
        })
    });
};
const $8116958daecdf4bd$var$formLoadingCss = null;
const $8116958daecdf4bd$var$formLoadingFullHeightCss = null;

});


parcelRegister("jQIyh", function(module, exports) {
$parcel$export(module.exports, "SignupForm", function () { return (parcelRequire("ddN1B")).SignupForm; });
$parcel$export(module.exports, "SignupFormSuccessUFOEvent", function () { return (parcelRequire("9ax0J")).SignupFormSuccessUFOEvent; });
$parcel$export(module.exports, "EmbeddedSignupForm", function () { return (parcelRequire("6mUgP")).EmbeddedSignupForm; });
parcelRequire("ddN1B");
parcelRequire("9ax0J");
parcelRequire("6mUgP");

});
parcelRegister("ddN1B", function(module, exports) {

$parcel$export(module.exports, "SignupForm", function () { return $e02a856af8e7cd76$export$cc15cfe224a6a69b; });

var $loA2J = parcelRequire("loA2J");

var $6WBIS = parcelRequire("6WBIS");

var $WKdxa = parcelRequire("WKdxa");
parcelRequire("ao0u9");
var $dxCBa = parcelRequire("dxCBa");
var $hFUS5 = parcelRequire("hFUS5");
const $e02a856af8e7cd76$export$cc15cfe224a6a69b = ({ emailFormOnly: emailFormOnly, animatedSocialBanner: animatedSocialBanner, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, bgColor: bgColor = "bgWhite", customSignInProviders: customSignInProviders, hideLegalText: hideLegalText })=>{
    const { productName: productName } = (0, $WKdxa.useSignupFormContext)();
    const { isAnimatedHero: isAnimatedHero } = (0, $6WBIS.usePaidJswProductTourContext)();
    let variant = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dxCBa.DefaultSignupForm), {});
    if (isAnimatedHero || emailFormOnly) variant = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hFUS5.PaidEmailForm), {
        animatedSocialBanner: animatedSocialBanner,
        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
        bgColor: bgColor,
        customSignInProviders: customSignInProviders,
        hideLegalText: hideLegalText
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $WKdxa.SignupAnalyticsContext), {
        productName: productName,
        children: variant
    });
};

});
parcelRegister("ao0u9", function(module, exports) {
$parcel$export(module.exports, "PaidEmailForm", function () { return (parcelRequire("hFUS5")).PaidEmailForm; });
$parcel$export(module.exports, "DefaultSignupForm", function () { return (parcelRequire("dxCBa")).DefaultSignupForm; });
parcelRequire("hFUS5");
parcelRequire("dxCBa");

});
parcelRegister("hFUS5", function(module, exports) {

$parcel$export(module.exports, "PaidEmailForm", function () { return $8f61a174033ef387$export$eb5413c805d258b4; });
/* paid-email-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $6oKbD = parcelRequire("6oKbD");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $9DfPf = parcelRequire("9DfPf");

var $WKdxa = parcelRequire("WKdxa");
const $8f61a174033ef387$var$confluenceEmbeddedExistingText = (0, $6x1qA.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});
const $8f61a174033ef387$export$eb5413c805d258b4 = ({ animatedSocialBanner: animatedSocialBanner, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, bgColor: bgColor = "bgWhite", customSignInProviders: customSignInProviders, hideLegalText: hideLegalText = false })=>{
    const { formError: formError, hasSubmitted: hasSubmitted, isEmailValid: isEmailValid, onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA, productKey: productKey, edition: edition, setIsEmailValid: setIsEmailValid, setTypeAheadEmail: setTypeAheadEmail, productName: productName } = (0, $WKdxa.useSignupFormContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        const customData = {
            webPlatform: "bxp-ui",
            reactComponent: "PaidEmailForm",
            experimentName: "paid-email-form",
            isLoggedIn: false
        };
        (0, $jgJpJ.ufoEventTryCloudSignupPageLoad).success({
            customData: customData
        });
        (0, $jgJpJ.ufoEventPaidSignupJSWLandingPageLoad).success({
            customData: {
                reactComponent: "PaidEmailForm",
                experimentName: "paid-email-form"
            }
        });
        (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: "embedded",
            productKey: productKey,
            edition: edition
        });
    }, [
        createAnalyticsEvent,
        productKey,
        edition
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: onSubmitWithReCAPTCHA,
        isDisabled: false,
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.InputEmail), {
                        setIsEmailValid: setIsEmailValid,
                        submitting: submitting,
                        setTypeAheadEmail: setTypeAheadEmail,
                        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles
                    }),
                    !hideLegalText && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1wybepq8 _vwz4bs82"
                        ]),
                        style: {
                            "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.EulaText), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.ButtonSubmit), {
                        "data-testid": "signup-form-submit",
                        submitting: submitting,
                        hasSubmitted: hasSubmitted,
                        isEmailValid: isEmailValid,
                        formError: false,
                        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles
                    }),
                    formError && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syazgryn _19pki2wt _2hwxidpf _otyr1tcg _18u0idpf",
                            "errorMessageText"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpUiSignup.SignupForm.formError",
                            defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>.",
                            values: {
                                contactUsLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: text,
                                        "aria-label": text,
                                        type: "inline",
                                        href: "/company/contact",
                                        className: "linkText"
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_179r14vf _vwz4400g _19pkviql _2hwx1j6v _otyrviql _18u01j6v _16jlkb7n"
                                ])
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                className: (0, $esG4f.default)([
                                    "_syaz1c68 _ect4bzd7 _k48p1nn1",
                                    "separatorText"
                                ]),
                                style: {
                                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "BxpUiSignup.SignupForm.orPaidExperiment",
                                    defaultMessage: "Or sign up with"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_179r14vf _vwz4400g _19pkviql _2hwx1j6v _otyrviql _18u01j6v _16jlkb7n"
                                ])
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.SignInButtons), {
                        hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles,
                        customSignInProviders: customSignInProviders
                    }),
                    animatedSocialBanner && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1pfh1ylp"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.AnimatedSocialProof), {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.ExistingProductText), {
                        messageOverride: $8f61a174033ef387$var$confluenceEmbeddedExistingText,
                        productName: productName,
                        bgColor: bgColor
                    })
                ]
            }))
    });
};
const $8f61a174033ef387$var$animatedSocialProof = null;
const $8f61a174033ef387$var$formErrorStyle = null;
const $8f61a174033ef387$var$legalTextCss = null;
const $8f61a174033ef387$var$orPaidSeparatorStyle = null;
const $8f61a174033ef387$var$separatorText = null;
const $8f61a174033ef387$var$separatorContainer = null;

});

parcelRegister("dxCBa", function(module, exports) {

$parcel$export(module.exports, "DefaultSignupForm", function () { return $3abd9b66f6cc1446$export$1ec51f8461f7bee0; });
/* default-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $akark = parcelRequire("akark");

var $9DfPf = parcelRequire("9DfPf");

var $WKdxa = parcelRequire("WKdxa");
const $3abd9b66f6cc1446$export$1ec51f8461f7bee0 = ()=>{
    const { bundle: bundle, edition: edition, showProductLogo: showProductLogo, products: products, productName: productName, isEmbedded: isEmbedded } = (0, $WKdxa.useSignupFormContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
        (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: (0, $jgJpJ.getPrimaryProductKeyFromBundle)(bundle),
            edition: edition
        });
    }, [
        createAnalyticsEvent,
        bundle,
        edition,
        isEmbedded
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const customData = {
            webPlatform: "bxp-ui",
            reactComponent: "DefaultSignupForm",
            isLoggedIn: false
        };
        (0, $jgJpJ.ufoEventTryCloudSignupPageLoad).success({
            customData: customData
        });
        if (isEmbedded) {
            (0, $jgJpJ.ufoEventPaidSignupJSWLandingPageLoad).success({
                customData: {
                    reactComponent: "DefaultSignupForm"
                }
            });
            (0, $jgJpJ.ufoEventPaidSignupConfluenceLandingPageLoad).success({
                customData: {
                    reactComponent: "DefaultSignupForm"
                }
            });
            (0, $jgJpJ.ufoEventPaidSignupJSMLandingPageLoad).success({
                customData: {
                    reactComponent: "DefaultSignupForm"
                }
            });
        } else (0, $jgJpJ.ufoEventTryCloudSignupPageLoad).success({
            customData: customData
        });
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $akark.SignupModuleWrapper), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $esG4f.default)([
                "_4cvr1fhb _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o"
            ]),
            children: [
                showProductLogo && /*#__PURE__*/ (0, $loA2J.jsx)($3abd9b66f6cc1446$var$ProductLogos, {
                    products: products
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    children: products.length > 1 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.headerBundle",
                        defaultMessage: "Get started"
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.header",
                        defaultMessage: "Get started with {product}",
                        values: {
                            product: productName
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    children: bundle === "jira-service-management-jira-software" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheaderJSWJSM",
                        defaultMessage: "It's free for up to 3 agents and 10 users."
                    }) : bundle === "jira-service-management" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheaderJSM",
                        defaultMessage: "Free for up to 3 agents"
                    }) : bundle === "jira-software" && edition === "standard" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheader.jsw.standard",
                        defaultMessage: "14-day free trial for unlimited users on the Standard plan \u2014 no credit card needed"
                    }) : bundle === "jira-software" && edition === "premium" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheader.jsw.premium",
                        defaultMessage: "30-day free trial for unlimited users on the Premium plan \u2014 no credit card needed"
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.EmailForm), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.ExistingProductText), {
                    productName: productName
                })
            ]
        })
    });
};
const $3abd9b66f6cc1446$var$ProductLogos = ({ products: products })=>{
    const [baseProduct, ...bundledProducts] = products;
    if (!baseProduct) return null;
    const { productKey: baseProductKey, productLogo: BaseProductLogo } = baseProduct;
    const isBundle = bundledProducts.length > 0;
    const size = isBundle ? "medium" : "large";
    if (!isBundle) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _6rthgktf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)(BaseProductLogo, {
            appearance: "brand",
            size: size
        }, baseProductKey)
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _6rthgktf _4cvr1h6o _gy1p1crf _1n261g80 _1p571y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)(BaseProductLogo, {
                appearance: "brand",
                size: size
            }, baseProductKey),
            bundledProducts.map(({ productKey: bundledProductKey, productLogo: BundledProductLogo })=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_1wyb1tcg _1pfhmyb0"
                            ]),
                            children: "+"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)(BundledProductLogo, {
                            appearance: "brand",
                            size: size
                        }, bundledProductKey)
                    ]
                }))
        ]
    });
};
const $3abd9b66f6cc1446$var$containerStyle = null;
const $3abd9b66f6cc1446$var$productLogoCss = null;
const $3abd9b66f6cc1446$var$multipleProductLogosCss = null;
const $3abd9b66f6cc1446$var$multipleProductLogosPlusCss = null;

});
parcelRegister("akark", function(module, exports) {

$parcel$export(module.exports, "SignupModuleWrapper", function () { return $a5cc370be4294f45$export$eecae687e7c61946; });
/* signup-module-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $a6bec = parcelRequire("a6bec");

var $jgJpJ = parcelRequire("jgJpJ");
const $a5cc370be4294f45$var$signupModule = null;
const $a5cc370be4294f45$var$fullHeightSignupModule = null;
const $a5cc370be4294f45$var$fullPageSignupModule = null;
const $a5cc370be4294f45$var$container = null;
const $a5cc370be4294f45$var$fullPageContainer = null;
const $a5cc370be4294f45$var$footer = null;
const $a5cc370be4294f45$export$eecae687e7c61946 = ({ fullPage: fullPage, fullHeight: fullHeight = true, hideFooter: hideFooter, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx21bp4 _ect41qje _1wyb8oy7 _1bah1yb4 _ca0q1k8s _u5f31j6v _n3td1k8s _19bv1j6v",
            fullPage && "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mpv1wug _15y11wug",
            fullHeight && "_1tke1us8 _15y110j7"
        ]),
        style: {
            "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _p12f1f23 _1bsb1osq _cadt1qje _8v2f1qje _iowe1h6o _1afj1h6o _1vfhqwb1 _1twlni7l _1xd21btq _rzbyidpf _8k2zidpf _nd4uidpf _9u9nidpf _k4bkidpf _ihmi78gw _1riqidpf _15cu78gw _11eb1kw7 _l5k14jg8 _1n461kwk _if5yidpf _1gnp1kwk _7e5bidpf _1g0f1k8s _cg41alr3 _1t2qalr3 _125xalr3 _doqyalr3 _zcqxbs82 _clfd1j6v _11pqidpf _q0a51j6v _c3k8idpf _1sgrepq8 _kminepq8 _43dsoelr _9m7f1r31 _rfqo1r31 _w7sw8stv _1bgk8stv _15a9nqa1 _1t0pnqa1",
                    fullPage && "_p12f1osq _kiyaidpf _1mt1idpf"
                ]),
                style: {
                    "--_1n7yiy6": (0, $43MIc.default)((0, $jgJpJ.fontSize).xl),
                    "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                },
                children: children
            }),
            !hideFooter && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_19pk1k8s _2hwx1wug _otyr1k8s _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $a6bec.AtlassianLogo), {
                    appearance: "brand",
                    size: "small",
                    testId: "atlassian-logo",
                    label: "Atlassian logo"
                })
            })
        ]
    });
};

});




parcelRegister("9ax0J", function(module, exports) {

$parcel$export(module.exports, "SignupFormSuccessUFOEvent", function () { return $3f42f0750934027f$export$44219095b16ac4f0; });

var $iSvIT = parcelRequire("iSvIT");

var $jgJpJ = parcelRequire("jgJpJ");
const $3f42f0750934027f$export$44219095b16ac4f0 = ()=>{
    (0, $iSvIT.useLayoutEffect)(()=>{
        (0, $jgJpJ.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: "bxp-ui",
                reactComponent: "DefaultSignupForm",
                isLoggedIn: false
            }
        });
    });
    return null;
};

});

parcelRegister("6mUgP", function(module, exports) {

$parcel$export(module.exports, "EmbeddedSignupForm", function () { return $7580e073cd6b04a9$export$7572837522fb3c8b; });

var $loA2J = parcelRequire("loA2J");

var $6kzTi = parcelRequire("6kzTi");

var $jgJpJ = parcelRequire("jgJpJ");

var $4toHd = parcelRequire("4toHd");
parcelRequire("gHQuP");
var $a5anJ = parcelRequire("a5anJ");
var $i8Gkd = parcelRequire("i8Gkd");
var $53H84 = parcelRequire("53H84");

var $WKdxa = parcelRequire("WKdxa");
const $7580e073cd6b04a9$var$variants = {
    "paid-lp-conf-features": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-conf-features"
    }),
    "paid-lp-confl-projectmgmt": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-projectmgmt"
    }),
    "paid-lp-confl-documentation": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-documentation"
    }),
    "paid-lp-confl-template": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "paid-lp-confl-template"
    }),
    "anchor-lp-conf-automation": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-automation"
    }),
    "anchor-lp-conf-collaboration": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-collaboration"
    }),
    "anchor-lp-conf-teamwork": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-teamwork"
    }),
    "anchor-lp-conf-work-management": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-work-management"
    }),
    "anchor-lp-conf-competitors": /*#__PURE__*/ (0, $loA2J.jsx)((0, $a5anJ.ConfluenceFeaturesPageEmbeddedSignupForm), {
        variant: "anchor-lp-conf-competitors"
    }),
    "default": /*#__PURE__*/ (0, $loA2J.jsx)((0, $i8Gkd.DefaultEmbeddedSignupForm), {}),
    "confluence-default": /*#__PURE__*/ (0, $loA2J.jsx)((0, $6kzTi.CFindEmbeddedSignupForm), {})
};
const $7580e073cd6b04a9$export$7572837522fb3c8b = ({ bundle: bundle, isUserLoggedIn: isUserLoggedIn, variantOverride: variantOverride })=>{
    const { productKey: productKey, productName: productName } = (0, $WKdxa.useSignupFormContext)();
    if (isUserLoggedIn && bundle) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4toHd.SiteNameContextProvider), {
        productKey: productKey,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $53H84.LoggedInForm), {})
    });
    let variantName = "default";
    if (productKey === (0, $jgJpJ.ProductKey).CONFLUENCE) variantName = "confluence-default";
    if (variantOverride) variantName = variantOverride;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $WKdxa.SignupAnalyticsContext), {
        productName: productName,
        children: $7580e073cd6b04a9$var$variants[variantName]
    });
};

});
parcelRegister("6kzTi", function(module, exports) {

$parcel$export(module.exports, "CFindEmbeddedSignupForm", function () { return $deef4e104104daf5$export$30d022a977c0a6db; });
/* cfind-embedded-signup.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $6JN6z = parcelRequire("6JN6z");

var $lp1yP = parcelRequire("lp1yP");

var $9DfPf = parcelRequire("9DfPf");

var $WKdxa = parcelRequire("WKdxa");

var $iWMXV = parcelRequire("iWMXV");

var $lN3YF = parcelRequire("lN3YF");
const $deef4e104104daf5$var$confluenceEmbeddedExistingText = (0, $6x1qA.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});
const $deef4e104104daf5$export$30d022a977c0a6db = ()=>{
    const { productName: productName, customHeader: customHeader } = (0, $WKdxa.useSignupFormContext)();
    const defaultHeader = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features",
        defaultMessage: "Goodbye silos, hello teamwork with Confluence"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lp1yP.EmbeddedSignupModuleWrapper), {
        hideFooter: true,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $esG4f.default)([
                "_4cvr1fhb _bfhku67f _16qsoopq _2rkogktf _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qzwfg _u5f312am _n3tdzwfg _19bv12am _1bsb1erl"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_y4tivbgk _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JN6z.BanditsHeaderWrapper), {
                        product: "confluence",
                        type: "header",
                        children: customHeader || defaultHeader
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1gpt _k48pocj5 _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6JN6z.BanditsHeaderWrapper), {
                        product: "confluence",
                        type: "subheader",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpUiSignup.SignupForm.subheader.1",
                            defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $iWMXV.EmailForm), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $lN3YF.SocialEndorsement), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.ExistingProductText), {
                    messageOverride: $deef4e104104daf5$var$confluenceEmbeddedExistingText,
                    productName: productName
                })
            ]
        })
    });
};
const $deef4e104104daf5$var$containerStyle = null;
const $deef4e104104daf5$var$headerStyle = null;
const $deef4e104104daf5$var$subheaderStyle = null;

});
parcelRegister("lp1yP", function(module, exports) {

$parcel$export(module.exports, "EmbeddedSignupModuleWrapper", function () { return $c29d0dbfba22be96$export$35f817a3baeda3fe; });
/* embedded-signup-module-wrapper.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $a6bec = parcelRequire("a6bec");

var $jgJpJ = parcelRequire("jgJpJ");
const $c29d0dbfba22be96$var$signupModule = null;
const $c29d0dbfba22be96$var$container = null;
const $c29d0dbfba22be96$var$footer = null;
const $c29d0dbfba22be96$export$35f817a3baeda3fe = ({ hideFooter: hideFooter, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _vchhusvi _1e0c1txw _2lx21bp4 _ect41qje _1wyb8oy7 _ca0qviql _u5f3viql _n3tdviql _19bvviql _1kmxviql _1ggm1kwk _1ykzviql _1mae1kwk _ie1cviql _78i21j6v _1db0viql _dpmd1j6v _i6jxviql _1lh71j6v _z3ncviql _wpai1j6v"
        ]),
        style: {
            "--_djwknj": (0, $43MIc.default)((0, $jgJpJ.fontSize).sm)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_p12fnl1e _1bsb1osq _cadt1qje _8v2f1qje _iowe1h6o _1afj1h6o _1vfhqwb1 _1twlni7l _1xd21btq _rzbyidpf _8k2zidpf _nd4uidpf _9u9nidpf _11eb1kw7 _l5k14jg8 _1n461kwk _if5yidpf _1gnp1kwk _7e5bidpf _1g0f1k8s _cg41alr3 _1t2qalr3 _125xalr3 _doqyalr3 _zcqxbs82 _clfd1j6v _11pqidpf _q0a51j6v _c3k8idpf _1sgrepq8 _kminepq8 _59381r31 _yha2glyw _1nmznqa1 _43dsoelr _1cayoelr _9m7f1r31 _rfqo1r31 _w7sw8stv _1bgk8stv _15a9nqa1 _1t0pnqa1"
                ]),
                style: {
                    "--_1n7yiy6": (0, $43MIc.default)((0, $jgJpJ.fontSize).xl),
                    "--_1h1y5xv": (0, $43MIc.default)((0, $jgJpJ.fontSize).xs)
                },
                children: children
            }),
            !hideFooter && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_19pk1k8s _2hwx1wug _otyridpf _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $a6bec.AtlassianLogo), {
                    appearance: "brand",
                    size: "small",
                    testId: "atlassian-logo",
                    label: "Atlassian logo"
                })
            })
        ]
    });
};

});

parcelRegister("iWMXV", function(module, exports) {

$parcel$export(module.exports, "EmailForm", function () { return $d9e071d77a1fa82e$export$89af2fd9aa25b6d8; });
/* email-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $6oKbD = parcelRequire("6oKbD");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $dWbel = parcelRequire("dWbel");

var $9DfPf = parcelRequire("9DfPf");

var $WKdxa = parcelRequire("WKdxa");
const $d9e071d77a1fa82e$export$89af2fd9aa25b6d8 = ()=>{
    const { isEmbedded: isEmbedded, productKey: productKey, edition: edition, formError: formError, hasSubmitted: hasSubmitted, isEmailValid: isEmailValid, onSubmitWithReCAPTCHA: onSubmitWithReCAPTCHA, setIsEmailValid: setIsEmailValid, setTypeAheadEmail: setTypeAheadEmail } = (0, $WKdxa.useSignupFormContext)();
    const intl = (0, $f6qj2.default)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const separatorText = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.or",
        defaultMessage: "Or continue with"
    });
    (0, $iSvIT.useEffect)(()=>{
        const dataFoundationsActionSubjectId = !!isEmbedded ? "embedded" : "standalone";
        if (analyticsClient) (0, $jgJpJ.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: productKey,
            edition: edition
        });
    }, [
        createAnalyticsEvent,
        productKey,
        edition,
        isEmbedded,
        analyticsClient
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
        onSubmit: onSubmitWithReCAPTCHA,
        isDisabled: false,
        children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsxs)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.InputEmail), {
                        setIsEmailValid: setIsEmailValid,
                        submitting: submitting,
                        setTypeAheadEmail: setTypeAheadEmail,
                        workCallout: true
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.ButtonSubmit), {
                        "data-testid": "signup-form-submit",
                        submitting: submitting,
                        hasSubmitted: hasSubmitted,
                        isEmailValid: isEmailValid,
                        formError: false
                    }),
                    formError && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_syazgryn _19pki2wt _2hwxidpf _otyr1tcg _18u0idpf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpUiSignup.SignupForm.formError",
                            defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>.",
                            values: {
                                contactUsLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: text,
                                        "aria-label": text,
                                        type: "inline",
                                        href: "/company/contact"
                                    })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_179r11xk _vwz4400g _19pkviql _2hwx1j6v _otyrviql _18u01j6v _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            className: (0, $esG4f.default)([
                                "_bfhku67f _ca0qidpf _u5f31j6v _n3tdidpf _19bv1j6v"
                            ]),
                            children: separatorText
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.SignInButtons), {})
                ]
            }))
    });
};
const $d9e071d77a1fa82e$var$formErrorStyle = null;
const $d9e071d77a1fa82e$var$orSeparatorStyle = null;
const $d9e071d77a1fa82e$var$orSeparatorSpanStyle = null;

});

parcelRegister("lN3YF", function(module, exports) {

$parcel$export(module.exports, "SocialEndorsement", function () { return $a85362096b094067$export$782656e60c9cecfd; });
/* social-endorsement.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1MbAx = parcelRequire("1MbAx");
const $a85362096b094067$var$carouselStyle = null;
const $a85362096b094067$var$trackStyle = null;
const $a85362096b094067$var$logoStyle = null;
const $a85362096b094067$var$SocialEndorsementComponent = ()=>{
    const logos = [
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/canva.svg",
            alt: "Canva",
            width: 95
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/nasa.svg",
            alt: "Nasa",
            width: 60
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/illumina.svg",
            alt: "Illumina",
            width: 103
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/docker.svg",
            alt: "Docker",
            width: 108
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/new-york-times.svg",
            alt: "The New York Times",
            width: 165
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/confluence/social-endorsement/audi.svg",
            alt: "Audi",
            width: 68
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "cfind-2675-social-proof",
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _4t3i14no _kqswh2mm _1q511tcg _1bsb1osq _vchh1ntv"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_y44v9j94 _1e0c1txw _zulpzwfg _kqswstnw"
            ]),
            children: [
                ...logos,
                ...logos
            ].map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: logo.src,
                        alt: logo.alt,
                        loading: "lazy",
                        width: logo.width,
                        className: (0, $esG4f.default)([
                            "_lcxvglyw _kdamllbs _4t3i14no _16bullbs"
                        ])
                    })
                }, index))
        })
    });
};
const $a85362096b094067$export$782656e60c9cecfd = (0, $1MbAx.withFeatureExposed)("cfind-2675-social-proof-paid", "true", $a85362096b094067$var$SocialEndorsementComponent);

});


parcelRegister("gHQuP", function(module, exports) {
$parcel$export(module.exports, "ConfluenceFeaturesPageEmbeddedSignupForm", function () { return (parcelRequire("a5anJ")).ConfluenceFeaturesPageEmbeddedSignupForm; });
$parcel$export(module.exports, "DefaultEmbeddedSignupForm", function () { return (parcelRequire("i8Gkd")).DefaultEmbeddedSignupForm; });
$parcel$export(module.exports, "LoggedInForm", function () { return (parcelRequire("53H84")).LoggedInForm; });
parcelRequire("6kzTi");
parcelRequire("a5anJ");
parcelRequire("i8Gkd");
parcelRequire("53H84");

});
parcelRegister("a5anJ", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFeaturesPageEmbeddedSignupForm", function () { return $a02c75a45b8462de$export$2394908a1a97673f; });
/* confluence-features-page-embedded.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $lp1yP = parcelRequire("lp1yP");

var $9DfPf = parcelRequire("9DfPf");

var $WKdxa = parcelRequire("WKdxa");
const $a02c75a45b8462de$var$confluenceEmbeddedExistingText = (0, $6x1qA.defineMessage)({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});
const $a02c75a45b8462de$export$2394908a1a97673f = ({ variant: variant })=>{
    const { productName: productName } = (0, $WKdxa.useSignupFormContext)();
    const headers = {
        "paid-lp-conf-features": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features",
            defaultMessage: "Goodbye silos, hello teamwork with Confluence"
        }),
        "anchor-lp-conf-competitors": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.competitors",
            defaultMessage: "Confluence is the #1 collaboration tool for productive teams"
        }),
        "anchor-lp-conf-work-management": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.work.management",
            defaultMessage: "Bring your team\u2019s work together with Confluence"
        }),
        "anchor-lp-conf-teamwork": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.teamwork",
            defaultMessage: "Accelerate teamwork and productivity with Confluence"
        }),
        "anchor-lp-conf-collaboration": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.collaboration",
            defaultMessage: "Turn ideas into action with Confluence"
        }),
        "anchor-lp-conf-automation": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.automation",
            defaultMessage: "Collaborate better with Confluence"
        }),
        "paid-lp-confl-template": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.template",
            defaultMessage: "There\u2019s a Confluence template for that"
        }),
        "paid-lp-confl-documentation": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.documentation",
            defaultMessage: "Technically superior documentation starts with Confluence"
        }),
        "paid-lp-confl-projectmgmt": /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "BxpUiSignup.EmbeddedSignupForm1466.header.confluence.project.management",
            defaultMessage: "Confluence makes project management easy"
        })
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lp1yP.EmbeddedSignupModuleWrapper), {
        hideFooter: true,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $esG4f.default)([
                "_4cvr1fhb _bfhku67f _16qsoopq _2rkogktf _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qzwfg _u5f312am _n3tdzwfg _19bv12am _1bsb1erl"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_y4tivbgk _y3gn1qpp"
                    ]),
                    children: headers[variant]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wyb1gpt _k48pocj5 _y3gn1qpp"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.SignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.EmailForm), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.ExistingProductText), {
                    messageOverride: $a02c75a45b8462de$var$confluenceEmbeddedExistingText,
                    productName: productName
                })
            ]
        })
    });
};
const $a02c75a45b8462de$var$containerStyle = null;
const $a02c75a45b8462de$var$headerStyle = null;
const $a02c75a45b8462de$var$subheaderStyle = null;

});

parcelRegister("i8Gkd", function(module, exports) {

$parcel$export(module.exports, "DefaultEmbeddedSignupForm", function () { return $82d21b13d4ccb8cc$export$ec3bbe4365c4cdfa; });
/* default-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $lp1yP = parcelRequire("lp1yP");

var $9DfPf = parcelRequire("9DfPf");

var $WKdxa = parcelRequire("WKdxa");
const $82d21b13d4ccb8cc$export$ec3bbe4365c4cdfa = ()=>{
    const { showProductLogo: showProductLogo, productLogos: productLogos, productName: productName } = (0, $WKdxa.useSignupFormContext)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lp1yP.EmbeddedSignupModuleWrapper), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-testid": "signup-form",
            className: (0, $esG4f.default)([
                "_4cvr1fhb _syaz1bqd _1e0c1txw _2lx21bp4 _1bah1h6o"
            ]),
            children: [
                showProductLogo && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bah1h6o _6rthgktf"
                    ]),
                    children: productLogos.map((ProductLogo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)(ProductLogo, {
                            appearance: "brand"
                        }, index))
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.EmbeddedSignupForm.header",
                        defaultMessage: "Get started with {product}",
                        values: {
                            product: productName
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        id: "BxpUiSignup.EmbeddedSignupForm.subheader.1",
                        defaultMessage: "It's free for up to 10 users \u2014 no credit card needed."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.EmailForm), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9DfPf.ExistingProductText), {
                    productName: productName
                })
            ]
        })
    });
};
const $82d21b13d4ccb8cc$var$containerStyle = null;
const $82d21b13d4ccb8cc$var$productLogoCss = null;

});

parcelRegister("53H84", function(module, exports) {

$parcel$export(module.exports, "LoggedInForm", function () { return $f4b5f74431d39c3d$export$c5d014cdd7dc976f; });
/* logged-in-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $47Euo = parcelRequire("47Euo");

var $jgJpJ = parcelRequire("jgJpJ");

var $4toHd = parcelRequire("4toHd");
const $f4b5f74431d39c3d$var$containerStyles = null;
const $f4b5f74431d39c3d$var$headerStyles = null;
const $f4b5f74431d39c3d$export$c5d014cdd7dc976f = ()=>{
    const intl = (0, $f6qj2.default)();
    const { userInfo: { name: name } } = (0, $4toHd.useSiteNameContext)();
    const headerText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.header",
        defaultMessage: "Welcome back, {name}"
    }, {
        name: (0, $jgJpJ.getFirstName)(name)
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_bfhku67f _2rkogktf _ca0q1ylp _u5f312am _n3td8vuz _19bv12am _1bsb1erl"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_k48pbfng"
                ]),
                children: headerText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47Euo.default), {
                WeekOneUser: null
            })
        ]
    });
};

});




parcelRegister("aHxuL", function(module, exports) {
$parcel$export(module.exports, "SiteNameForm", function () { return (parcelRequire("2oRUX")).SiteNameForm; });
parcelRequire("2oRUX");

});
parcelRegister("2oRUX", function(module, exports) {

$parcel$export(module.exports, "SiteNameForm", function () { return $a8dbe5e19137898e$export$1fa728897f20426d; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $bLpA6 = parcelRequire("bLpA6");

var $9O063 = parcelRequire("9O063");

var $iu8Ap = parcelRequire("iu8Ap");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1MbAx = parcelRequire("1MbAx");

var $lrVTP = parcelRequire("lrVTP");

var $jgJpJ = parcelRequire("jgJpJ");

var $akark = parcelRequire("akark");

var $WKdxa = parcelRequire("WKdxa");
parcelRequire("bSrj2");
var $S65DD = parcelRequire("S65DD");

var $l8lyw = parcelRequire("l8lyw");

var $dkKVh = parcelRequire("dkKVh");

var $4TKhr = parcelRequire("4TKhr");

var $9O063 = parcelRequire("9O063");

var $4toHd = parcelRequire("4toHd");
const $a8dbe5e19137898e$export$1fa728897f20426d = ({ isNewUser: isNewUser, hasRebrandedSignupFormStyles: hasRebrandedSignupFormStyles, bgColor: bgColor })=>{
    const { productKey: productKey } = (0, $WKdxa.useSignupFormContext)();
    const { pathname: pathname, search: search } = (0, $lrVTP.useLocation)();
    const queryParams = new URLSearchParams(search);
    const hasConfluenceD0to6 = (0, $iMdoL.useConfluenceD0to6)();
    const hasJiraD0to6 = (0, $iMdoL.useJiraD0to6)();
    const userIsManagedByGuardOrgAndHasSites = (0, $iMdoL.useUserIsManagedByGuardOrgAndHasSites)();
    // guard only shows up on the signup page
    const guardReturnToProductEnabled = pathname.endsWith("/try/cloud/signup");
    const shouldShowGuardReturnToProduct = guardReturnToProductEnabled && userIsManagedByGuardOrgAndHasSites;
    const variant = (0, $iSvIT.useMemo)(()=>{
        if (shouldShowGuardReturnToProduct) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $S65DD.GuardReturnToProduct), {});
        if (hasRebrandedSignupFormStyles) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $akark.SignupModuleWrapper), {
            hideFooter: true,
            fullPage: false,
            fullHeight: false,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {
                showSubheader: false,
                isOnDarkBackground: bgColor === "bgWhite" ? false : true
            })
        });
        if (productKey === (0, $jgJpJ.ProductKey).JIRA_SOFTWARE) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
            ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bLpA6.JiraLogo), {
                size: "xlarge",
                appearance: "brand"
            }),
            children: hasJiraD0to6 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
                experimentKey: "jfind-contact-expand-ii",
                group: "Test",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4TKhr.CobrandedContactExpand), {
                    productKeyForExpand: (0, $jgJpJ.ProductKey).JIRA_SOFTWARE
                })
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {})
        });
        if (productKey === (0, $jgJpJ.ProductKey).CONFLUENCE) {
            // Do not show contact expand if user clicked on a "create new" link
            const createNewWorkspace = queryParams.get("createNew") === "true";
            if (isNewUser) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
                ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.CobrandedProductLogo), {}),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.ConfluenceNewUserWorkspaceNameForm), {})
            });
            else if (hasConfluenceD0to6) // contact-expand
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
                experimentKey: "cfind-2658_redirect_contact_expand_to_product",
                group: "Test",
                conditions: [
                    !createNewWorkspace
                ],
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
                    ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.CobrandedProductLogo), {}),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4TKhr.CobrandedContactExpand), {
                        productKeyForExpand: (0, $jgJpJ.ProductKey).CONFLUENCE
                    })
                })
            });
            else // existing-user or crossflow
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
                ProductLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.CobrandedProductLogo), {}),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {})
            });
        }
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $akark.SignupModuleWrapper), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l8lyw.DefaultSiteName), {})
        });
    }, [
        shouldShowGuardReturnToProduct,
        hasJiraD0to6,
        hasRebrandedSignupFormStyles,
        productKey,
        isNewUser,
        hasConfluenceD0to6,
        bgColor
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const customData = {
            webPlatform: "bxp-ui",
            reactComponent: "SiteNameForm",
            isLoggedIn: true
        };
        (0, $jgJpJ.ufoEventTryCloudSignupPageLoad).success({
            customData: customData
        });
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4toHd.SiteNameContextProvider), {
        productKey: productKey,
        isNewUser: isNewUser,
        children: variant
    });
};

});
parcelRegister("bSrj2", function(module, exports) {
$parcel$export(module.exports, "GuardReturnToProduct", function () { return (parcelRequire("S65DD")).GuardReturnToProduct; });
parcelRequire("S65DD");

});
parcelRegister("S65DD", function(module, exports) {

$parcel$export(module.exports, "GuardReturnToProduct", function () { return $f7d6ac9df5aedd70$export$ca1f1cdc01d1b736; });
/* guard-return-to-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $bLpA6 = parcelRequire("bLpA6");

var $91nJf = parcelRequire("91nJf");

var $iu8Ap = parcelRequire("iu8Ap");

var $jgJpJ = parcelRequire("jgJpJ");

var $11sdu = parcelRequire("11sdu");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $1MbAx = parcelRequire("1MbAx");

var $WKdxa = parcelRequire("WKdxa");

var $9O063 = parcelRequire("9O063");

var $dkKVh = parcelRequire("dkKVh");

var $gkgE0 = parcelRequire("gkgE0");
const $f7d6ac9df5aedd70$export$ca1f1cdc01d1b736 = ()=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(false);
    const { productName: productName, productKey: productKey } = (0, $WKdxa.useSignupFormContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const sites = (0, $iMdoL.useManagingOrgUserSites)();
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const orgId = profile === null || profile === void 0 ? void 0 : (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    const clickGoToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToReturnToProductScreen",
            attributes: {
                orgId: orgId,
                productName: productName
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: clickGoToExistingWorkspace,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const goToExistingWorkspaceMessage = formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    const clickGoToSiteNamingScreen = ()=>{
        setShowSiteNaming(true);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "guardGoToSiteNamingScreen",
            attributes: {
                orgId: orgId,
                productName: productName
            }
        }).fire();
    };
    const goToSiteNamingMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: clickGoToSiteNamingScreen,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itgrf3 _2rkogrf3 _syaz17la _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const goToSiteNamingMessage = formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, goToSiteNamingMessageValues);
    return (sites === null || sites === void 0 ? void 0 : sites.length) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1MbAx.FeatureExposed), {
        experimentKey: "signup-guard-return-to-product",
        group: "treatment",
        metadata: {
            orgId: orgId
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iu8Ap.SignupBackgroundLayout), {
            ProductLogo: productKey === (0, $jgJpJ.ProductKey).CONFLUENCE ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9O063.CobrandedProductLogo), {}) : productKey === (0, $jgJpJ.ProductKey).DEVAI ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $11sdu.RovoDevAgentsLogo), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $bLpA6.JiraLogo), {
                size: "xlarge",
                appearance: "brand"
            }),
            children: showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _1tke1lk4 _zulp7vkz _ae4v1yb4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1wybdlk8 _k48pbfng _y3gn1h6o"
                        ]),
                        children: goToExistingWorkspaceMessage
                    })
                ]
            }) : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _1tke1lk4 _zulp7vkz _ae4v1yb4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkgE0.SitesList), {
                        sites: sites
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1wybdlk8 _k48pbfng _y3gn1h6o"
                        ]),
                        children: goToSiteNamingMessage
                    })
                ]
            })
        })
    }) : null;
};
const $f7d6ac9df5aedd70$var$containerCss = null;
const $f7d6ac9df5aedd70$var$goToLinkCss = null;
const $f7d6ac9df5aedd70$var$goToMessageCss = null;

});
parcelRegister("dkKVh", function(module, exports) {

$parcel$export(module.exports, "Adg4SiteNameForm", function () { return $f367f9738dc1eb77$export$968b755aaceecde4; });
/* site-name-form.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $6oKbD = parcelRequire("6oKbD");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $gDAhb = parcelRequire("gDAhb");

var $4toHd = parcelRequire("4toHd");

var $8lfjs = parcelRequire("8lfjs");
parcelRequire("15W0K");
var $lQzxd = parcelRequire("lQzxd");
const $f367f9738dc1eb77$export$e6873bfe3b33e63d = ({ isOnDarkBackground: isOnDarkBackground = false })=>{
    var _profile_attributes;
    const intl = (0, $f6qj2.default)();
    const { isNewUser: isNewUser, showSitePickerState: [showSitePicker, setShowSitePicker], productData: { productKey: productKey } } = (0, $4toHd.useSiteNameContext)();
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const [hasAvailableSites, setHasAvailableSites] = (0, $iSvIT.useState)(false);
    let toggleYourSiteButtonText;
    if (productKey === (0, $jgJpJ.ProductKey).CONFLUENCE) toggleYourSiteButtonText = showSitePicker ? intl.formatMessage({
        id: "BxpUiSignup.nameSite.createNewWorkspaceButton",
        defaultMessage: "Create a new workspace"
    }) : intl.formatMessage({
        id: "BxpUiSignup.nameSite.visitExistingWorkspaceButton",
        defaultMessage: "Visit an existing workspace"
    });
    else toggleYourSiteButtonText = showSitePicker ? intl.formatMessage({
        id: "BxpUiSignup.nameSite.startNewSiteButton",
        defaultMessage: "Start a new site"
    }) : intl.formatMessage({
        id: "BxpUiSignup.nameSite.useExistingSiteButton",
        defaultMessage: "Use an existing site"
    });
    (0, $iSvIT.useEffect)(()=>{
        if (!profile.requestInProgress) {
            var _profile_attributes;
            var _profile_attributes_existingSites_filter;
            const filteredAvailableSites = (_profile_attributes_existingSites_filter = (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites.filter(({ products: products })=>!products.some((product)=>product.productKey === productKey))) !== null && _profile_attributes_existingSites_filter !== void 0 ? _profile_attributes_existingSites_filter : [];
            setHasAvailableSites(filteredAvailableSites.length > 0);
            setShowSitePicker(filteredAvailableSites.length > 0);
        }
    }, [
        (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : _profile_attributes.existingSites,
        profile.requestInProgress,
        productKey,
        setShowSitePicker
    ]);
    return isNewUser ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "adg4-site-name-input",
                className: (0, $esG4f.default)([
                    "_pqyq183y _84yz183y _62vcmccc _9fwgmccc _mo2i1hlo _1451bzd7 _lsdidlk8 _1ilx1nn1 _lonvgktf",
                    isOnDarkBackground && "_mo2i121t"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDAhb.InputSiteName), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_syaz1hlo _ect4bzd7 _1wyb1crf _vwz4f6fq _k48p1nn1 _19pk1kwk _2hwxidpf _otyridpf _18u0idpf",
                    isOnDarkBackground && "_syaz121t"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "BxpUiSignup.nameSite.inputSiteNameMessage",
                    defaultMessage: "This site name is just a suggestion. Feel free to change to something your team will recognize."
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            showSitePicker ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "adg4-site-picker",
                className: (0, $esG4f.default)([
                    "_pqyq183y _84yz183y _62vcmccc _9fwgmccc _mo2i1hlo _1451bzd7 _lsdidlk8 _1ilx1nn1 _lonvgktf",
                    isOnDarkBackground && "_mo2i121t"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: productKey === (0, $jgJpJ.ProductKey).CONFLUENCE ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lfjs.WorkspacePickerField), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lfjs.SitePickerField), {})
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "adg4-site-name-input",
                className: (0, $esG4f.default)([
                    "_pqyq183y _84yz183y _62vcmccc _9fwgmccc _mo2i1hlo _1451bzd7 _lsdidlk8 _1ilx1nn1 _lonvgktf",
                    isOnDarkBackground && "_mo2i121t"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: productKey === (0, $jgJpJ.ProductKey).CONFLUENCE ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDAhb.InputWorkspaceName), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDAhb.InputSiteName), {})
            }),
            hasAvailableSites && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "adg4-available-sites-button",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDAhb.ArrowLinkButton), {
                    text: toggleYourSiteButtonText,
                    onClick: ()=>setShowSitePicker(!showSitePicker),
                    isOnDarkBackground: isOnDarkBackground
                })
            })
        ]
    });
};
const $f367f9738dc1eb77$export$968b755aaceecde4 = ({ showSubheader: showSubheader = true, isOnDarkBackground: isOnDarkBackground = false })=>{
    const intl = (0, $f6qj2.default)();
    const { userInfo: { name: name }, isNewUser: isNewUser, isSubmittingState: [isSubmitting], activateSite: activateSite, productData: { productKey: productKey } } = (0, $4toHd.useSiteNameContext)();
    let subHeaderText;
    if (isNewUser) subHeaderText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.cobrandedNewUserSubHeader",
        defaultMessage: "Sites are the shared space where people organize teams, work, and projects."
    });
    else if (productKey === (0, $jgJpJ.ProductKey).DEVAI) subHeaderText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.devAiJoinBetaSubHeader",
        defaultMessage: "Join the free beta program"
    });
    else subHeaderText = intl.formatMessage({
        id: "BxpUiSignup.nameSite.cobrandedSubHeader",
        defaultMessage: "It\u2019s free for up to 10 users - no credit card needed."
    });
    const siteNameAgreeButton = intl.formatMessage({
        id: "BxpUiSignup.nameSite.continueButton",
        defaultMessage: "Continue"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "adg4-site-name-form",
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o",
                            isOnDarkBackground && "_syaz121t"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: isNewUser ? /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                            className: (0, $esG4f.default)([
                                "_kqswh2mm"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "signupForm.accountCreation.cobrandedLoggedOutHeader",
                                    defaultMessage: `Create a <accentImage>site</accentImage>`,
                                    values: {
                                        accentImage: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                                                children: text
                                            })
                                    }
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                                    "aria-hidden": "true",
                                    fill: "#FCA700",
                                    viewBox: "0 0 57 52",
                                    className: (0, $esG4f.default)([
                                        "_4t3i1ex1 _152td439 _rjxp1muf _kqswstnw _1bsb1mcy"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M43.9096 31.989C44.2964 32.1979 50.1032 30.4768 48.3209 29.7729C47.7086 29.434 47.1876 29.537 47.0824 30.1563C46.7711 29.0152 45.8277 30.6914 45.2428 30.3744C45.338 29.5426 43.9174 31.4167 44.1295 30.5384C37.6167 30.3944 25.6493 39.724 40.8255 33.2041C39.218 33.0188 40.6554 32.5298 41.3794 32.6287C40.4962 33.7793 43.3258 32.5457 43.8251 32.1261C42.9181 32.2503 44.3277 31.315 43.9065 31.9866L43.9096 31.989Z"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M31.1742 23.4941C32.0038 23.3481 34.8483 17.2583 35.2257 16.6666C35.7963 15.2515 33.8616 15.3637 33.6797 16.5353C33.5454 16.7474 33.1876 18.4271 32.7181 17.7781C31.123 18.3209 31.2287 21.2383 29.8684 21.5744C30.1331 21.9302 29.6966 22.4398 29.8375 22.6819C29.4217 22.6843 29.2562 23.2605 29.3603 23.2987C27.7702 24.9228 30.1396 26.3595 30.8463 24.2051C30.9274 24.2847 31.3634 23.8695 31.1748 23.4996L31.1742 23.4941Z"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M8.6666 15.2222C8.02491 16.2514 7.96222 15.2487 8.28065 14.7497C9.05234 15.52 8.82473 13.5428 8.54045 13.0616C8.52243 13.2717 8.17 13.3446 8.18227 12.9105C9.08124 13.2088 9.17211 7.72002 7.35544 10.3155C7.36042 10.4093 8.06672 10.4491 7.84889 10.5596C6.77715 10.3778 7.53675 11.2383 7.62227 11.4811C7.06702 11.477 7.58662 11.707 7.35778 11.7688C6.60614 11.4733 7.8784 12.8725 7.13341 12.5375C6.01834 13.7974 7.55678 16.2818 6.53876 17.2452C7.79737 17.9053 5.99454 21.9334 8.35492 20.3752C8.8673 18.6393 9.14873 17.2179 8.6666 15.2222Z"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M21.257 4.74268C19.536 4.31212 19.9685 8.08877 19.2823 9.11742C18.2988 10.3626 15.0337 23.7231 18.3519 20.2458C19.306 16.1939 20.7963 13.0387 21.3321 7.97975C21.4791 7.16432 22.4539 4.63025 21.257 4.74268Z"
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                            d: "M37.0965 44.953C36.1393 46.3589 34.6992 44.6262 33.7861 45.783C32.4207 48.0004 45.1215 48.6579 44.6732 46.3948C44.025 44.501 38.0156 45.7761 37.0965 44.953Z"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $lQzxd.WelcomeBackHeading), {
                            name: name
                        })
                    }),
                    showSubheader && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o",
                            isOnDarkBackground && "_syaz121t"
                        ]),
                        style: {
                            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                        },
                        children: subHeaderText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
                onSubmit: activateSite,
                isDisabled: false,
                children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $loA2J.jsx)("form", (0, $6iHNw._)((0, $7Knp0._)({}, formProps), {
                        autoComplete: "off",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_19pk1tcg _2hwxidpf _otyr1tcg _18u0idpf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)($f367f9738dc1eb77$export$e6873bfe3b33e63d, {
                                        isOnDarkBackground: isOnDarkBackground
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_14hp1osq"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                        isDisabled: submitting || isSubmitting,
                                        isLoading: submitting || isSubmitting,
                                        type: "submit",
                                        dataEventProps: {
                                            "data-product-key": "jira",
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "siteName",
                                            "data-label": "continue-or-agree",
                                            "data-label-english": siteNameAgreeButton,
                                            "data-track-event": "jira-site-name.site-name-form.atlas-66195.site-name"
                                        },
                                        color: isOnDarkBackground ? "yellow" : undefined,
                                        children: siteNameAgreeButton
                                    })
                                })
                            ]
                        })
                    }))
            })
        ]
    });
};
const $f367f9738dc1eb77$var$containerCss = null;
const $f367f9738dc1eb77$var$headerGroupCss = null;
const $f367f9738dc1eb77$var$headerCss = null;
const $f367f9738dc1eb77$var$darkBackgroundTextStyles = null;
const $f367f9738dc1eb77$var$formWrapperCss = null;
const $f367f9738dc1eb77$var$suggestionStyles = null;
const $f367f9738dc1eb77$var$buttonStyles = null;
const $f367f9738dc1eb77$var$inputAndLabelStyles = null;
const $f367f9738dc1eb77$var$darkBackgroundInputAndLabelStyles = null;
const $f367f9738dc1eb77$var$accentImageSpanCss = null;
const $f367f9738dc1eb77$var$accentImageCss = null;

});
parcelRegister("15W0K", function(module, exports) {
$parcel$export(module.exports, "WelcomeBackHeading", function () { return (parcelRequire("lQzxd")).WelcomeBackHeading; });
parcelRequire("lQzxd");

});
parcelRegister("lQzxd", function(module, exports) {

$parcel$export(module.exports, "WelcomeBackHeading", function () { return $3de26478ec782459$export$f8a24991e7eb3d8f; });
/* welcome-back-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $jgJpJ = parcelRequire("jgJpJ");
const $3de26478ec782459$export$f8a24991e7eb3d8f = ({ name: name })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "BxpSignup.SiteExpansionForm.cobrandedHeader",
        defaultMessage: "<scribbleSpan>Welcome</scribbleSpan> back, {name}",
        values: {
            name: (0, $jgJpJ.getFirstName)(name),
            scribbleSpan: $3de26478ec782459$var$scribbleSpan
        }
    });
};
const $3de26478ec782459$var$scribbleSpan = (children)=>/*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                "aria-hidden": true,
                viewBox: "0 0 105 17",
                className: (0, $esG4f.default)([
                    "_lswuh727 _4t3io7ao _u7co1bs0 _1e02idpf _kqswstnw _t9ec1bh4 _1bsb1l8a"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M104.435 9.68613C86.4938 6.51631 73.1262 13.83 55.0489 7.43996C54.1658 10.0608 51.9298 13.3276 48.6487 13.3318C51.3855 13.3082 55.8543 6.49074 51.3954 11.0379C48.7638 14.5108 37.5257 10.0724 46.1409 13.2376C40.1743 12.5113 34.7527 8.16936 30.7652 4.31768C24.1184 -1.18196 29.0775 9.35501 24.148 14.5541C17.1646 21.7785 -3.47552 2.46837 0.735557 2.51293C3.38441 4.93365 6.96197 6.46719 8.41505 9.13148C34.4142 25.1383 15.8926 -4.08831 31.4374 0.975475C56.6666 21.4402 44.0238 3.05288 58.9761 4.49783C67.6031 11.908 104.856 0.972575 104.442 9.68622L104.435 9.68613Z"
                })
            })
        ]
    });
const $3de26478ec782459$var$accentImageCss = null;
const $3de26478ec782459$var$scribbleSpanCss = null;

});



parcelRegister("gkgE0", function(module, exports) {

$parcel$export(module.exports, "SitesList", function () { return $96f13c8e44724a10$export$e2789664959efdd3; });
/* sites-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $WKdxa = parcelRequire("WKdxa");
parcelRequire("15W0K");
var $lQzxd = parcelRequire("lQzxd");
const $96f13c8e44724a10$export$e2789664959efdd3 = ({ sites: sites })=>{
    var _profile_attributes_managingOrg, _profile_attributes;
    const { productKey: productKey } = (0, $WKdxa.useSignupFormContext)();
    const { productName: productName } = (0, $jgJpJ.getProductData)(productKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { profile: profile, user: { email: email, name: name } } = (0, $iMdoL.useUserContext)();
    const orgId = (_profile_attributes = profile.attributes) === null || _profile_attributes === void 0 ? void 0 : (_profile_attributes_managingOrg = _profile_attributes.managingOrg) === null || _profile_attributes_managingOrg === void 0 ? void 0 : _profile_attributes_managingOrg.orgId;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c11p5 _zulp1tcg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _zulpu2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lQzxd.WelcomeBackHeading), {
                            name: name
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.1",
                            defaultMessage: "Pick up where you left off in {productName}",
                            values: {
                                productName: productName
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                    defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                    values: {
                        email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                            className: (0, $esG4f.default)([
                                "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                            ]),
                            children: email
                        }),
                        switchAccountLink: $96f13c8e44724a10$var$switchAccountLink
                    }
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4cvr1h6o _1e0c11p5 _1bsb1osq _1jc21k1x _1mbp1wug"
                ]),
                children: sites.map(({ displayName: displayName, url: url })=>/*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                        href: $96f13c8e44724a10$var$getIdentityUrl({
                            url: url,
                            productKey: productKey
                        }),
                        onClick: (e)=>{
                            e.preventDefault(); // wait for event to fire
                            createAnalyticsEvent({
                                eventType: "ui",
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "guardClickReturnToProductButton",
                                attributes: {
                                    orgId: orgId,
                                    productName: productName
                                }
                            }).fire();
                            window.location.href = $96f13c8e44724a10$var$getIdentityUrl({
                                url: url,
                                productKey: productKey
                            });
                        },
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _179rzgxb _1e0c11p5 _zulp1y44 _yv0e9sye _1bah1yb4 _ca0q7vkz _u5f3ftgi _n3td7vkz _19bvftgi _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82 _8gg5glyw"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1syg"
                                ]),
                                style: {
                                    "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
                                },
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_k48p1nn1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: productName
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_syaz131l _1reo15vq _18m915vq _1bto1l2s _o5721q9c _1wybdlk8"
                                        ]),
                                        children: displayName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_p12f13i4 _1e0c1txw _1bahesu3"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                    variant: "secondary",
                                    size: "small",
                                    color: "black",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "bxpSignup.siteExpansion.goToProduct",
                                        defaultMessage: "Go to {productName}",
                                        values: {
                                            productName: productName
                                        }
                                    })
                                })
                            })
                        ]
                    }, url))
            })
        ]
    });
};
const $96f13c8e44724a10$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $96f13c8e44724a10$var$getIdentityUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/jira`,
                application: "jira"
            })}`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/wiki`,
                application: "confluence"
            })}`;
        case (0, $jgJpJ.ProductKey).DEVAI:
            return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: `${url}/rovodev`,
                application: "devai"
            })}`;
        default:
            return url;
    }
};
const $96f13c8e44724a10$var$containerCss = null;
const $96f13c8e44724a10$var$headerGroupCss = null;
const $96f13c8e44724a10$var$headerCss = null;
const $96f13c8e44724a10$var$switchAccountSubheader = null;
const $96f13c8e44724a10$var$sitesListCss = null;
const $96f13c8e44724a10$var$siteBoxCss = null;
const $96f13c8e44724a10$var$productNameCss = null;
const $96f13c8e44724a10$var$siteCss = null;
const $96f13c8e44724a10$var$siteNameCss = null;
const $96f13c8e44724a10$var$goToSiteButtonContainerCss = null;
const $96f13c8e44724a10$var$emailCss = null;
const $96f13c8e44724a10$var$switchAccountLinkCss = null;

});



parcelRegister("4TKhr", function(module, exports) {

$parcel$export(module.exports, "CobrandedContactExpand", function () { return $61021b7621e86001$export$c02e6a955b961e26; });
/* cobranded-contact-expand.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $5ohHq = parcelRequire("5ohHq");

var $WKdxa = parcelRequire("WKdxa");

var $18EPo = parcelRequire("18EPo");

var $dkKVh = parcelRequire("dkKVh");
const $61021b7621e86001$export$c02e6a955b961e26 = ({ productKeyForExpand: productKeyForExpand })=>{
    const createNewWorkspace = (0, $iSvIT.useMemo)(()=>{
        if (typeof window === "undefined") return false;
        const queryParams = new URLSearchParams(window.location.search);
        return queryParams.get("createNew") === "true";
    }, []);
    const [showSiteNaming, setShowSiteNaming] = (0, $iSvIT.useState)(createNewWorkspace);
    const { productName: productName } = (0, $WKdxa.useSignupFormContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const clickReturnToExistingWorkspace = ()=>{
        setShowSiteNaming(false);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "contactExpandGoToReturnToProductScreen",
            attributes: {
                productName: productName
            }
        }).fire();
    };
    const goToExistingWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: clickReturnToExistingWorkspace,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l3l3k2"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                },
                children: str
            })
    };
    const goToExistingWorkspaceMessage = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedGoToExistingWorkspace",
        defaultMessage: "or <link>visit an existing workspace</link>"
    }, goToExistingWorkspaceMessageValues) : intl.formatMessage({
        id: "bxpSignup.companyExpand.cobrandedReturnToJoinSites",
        defaultMessage: "or <link>join an existing site</link>"
    }, goToExistingWorkspaceMessageValues);
    return showSiteNaming ? /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _1tke1lk4 _ae4v1yb4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dkKVh.Adg4SiteNameForm), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: goToExistingWorkspaceMessage
            })
        ]
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $18EPo.CobrandedReturnToExistingProduct), {
        productKeyForExpand: productKeyForExpand,
        exitView: ()=>{
            setShowSiteNaming(true);
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "contactExpandGoToSiteNamingScreen",
                attributes: {
                    productName: productName
                }
            }).fire();
        }
    });
};
const $61021b7621e86001$var$containerCss = null;
const $61021b7621e86001$var$goToExistingWorkspaceLinkCss = null;
const $61021b7621e86001$var$goToExistingWorkspaceMessageCss = null;

});
parcelRegister("18EPo", function(module, exports) {

$parcel$export(module.exports, "CobrandedReturnToExistingProduct", function () { return $255f9296a7acccf2$export$1eeead6b5d168927; });
/* cobranded-return-to-existing-product.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $5ohHq = parcelRequire("5ohHq");

var $WKdxa = parcelRequire("WKdxa");
parcelRequire("15W0K");
var $lQzxd = parcelRequire("lQzxd");
const $255f9296a7acccf2$export$1eeead6b5d168927 = ({ exitView: exitView, productKeyForExpand: productKeyForExpand })=>{
    const d0to6JiraSite = (0, $iMdoL.useProductD0to6Site)({
        productKey: productKeyForExpand
    });
    const { productKey: productKey } = (0, $WKdxa.useSignupFormContext)();
    const { user: { email: email, name: name } } = (0, $iMdoL.useUserContext)();
    const { productName: productName } = (0, $jgJpJ.getProductData)(productKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const goToProductButtonText = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToWorkspace",
        defaultMessage: "Go to workspace"
    }) : intl.formatMessage({
        id: "bxpSignup.siteExpansion.goToProduct",
        defaultMessage: "Go to {productName}"
    }, {
        productName: productName
    });
    const createNewWorkspaceMessageValues = {
        link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                onClick: exitView,
                className: (0, $esG4f.default)([
                    "_bfhkmzrp _19itidpf _2rkoidpf _syaz17la _80omtlke _1wyb1kw7 _k48p1kw7 _1tke1wug _1ul91wug _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _4bfu1snc _1hms14l6 _ajmmvv82 _30l31ep1"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                },
                children: str
            })
    };
    const createNewWorkspaceMessage = productKeyForExpand === (0, $jgJpJ.ProductKey).CONFLUENCE ? intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedConfluenceCreateNewWorkspaceLink",
        defaultMessage: "or <link>create a new workspace</link>"
    }, createNewWorkspaceMessageValues) : intl.formatMessage({
        id: "BxpSignup.SiteExpansionForm.cobrandedJiraCreateNewWorkspaceLink",
        defaultMessage: "or <link>start a new site</link>"
    }, createNewWorkspaceMessageValues);
    return !d0to6JiraSite ? null : /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _1tke1lk4 _ae4v1yb4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _4cvr1h6o _syaz1bqd _zulp1tcg _19pk1wug _2hwxidpf _otyr1wug _18u0idpf"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c11p5 _zulpu2gc"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lQzxd.WelcomeBackHeading), {
                                    name: name
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.1",
                                    defaultMessage: "Pick up where you left off in {productName}",
                                    values: {
                                        productName: productName
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect4bzd7 _1wybdlk8 _y3gn1h6o"
                        ]),
                        style: {
                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "BxpSignup.SiteExpansionForm.cobrandedSubheader.2",
                            defaultMessage: "You\u2019re logged in as {email}. <switchAccountLink>Switch account</switchAccountLink>",
                            values: {
                                email: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                    className: (0, $esG4f.default)([
                                        "_k48pni7l _ct361wug _1i4q1hna _1nmz1hna _slp31hna"
                                    ]),
                                    children: email
                                }),
                                switchAccountLink: $255f9296a7acccf2$var$switchAccountLink
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        "data-testid": "return-to-existing-product",
                        className: (0, $esG4f.default)([
                            "_4cvr1h6o _1e0c11p5 _1bsb1osq _19ityzqy _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _2rkoftgi"
                        ]),
                        style: {
                            "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                            href: $255f9296a7acccf2$var$getProductUrl({
                                url: d0to6JiraSite.url,
                                productKey: productKey
                            }),
                            onClick: (e)=>{
                                e.preventDefault(); // wait for event to fire
                                createAnalyticsEvent({
                                    eventType: "ui",
                                    action: "clicked",
                                    actionSubject: "button",
                                    actionSubjectId: "contactExpandClickReturnToProductButton",
                                    attributes: {
                                        productName: productName
                                    }
                                }).fire();
                                window.location.href = $255f9296a7acccf2$var$getProductUrl({
                                    url: d0to6JiraSite.url,
                                    productKey: productKey
                                });
                            },
                            className: (0, $esG4f.default)([
                                "_4cvr1h6o _1e0c1txw _1bah1yb4 _1bsb1osq _9oik1snc _1bnxagmp _jf4cvv82"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1wyb1syg _1reo15vq _18m915vq"
                                    ]),
                                    style: {
                                        "--_1jvo4a6": (0, $43MIc.default)((0, $jgJpJ.fontSize).md)
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: (0, $esG4f.default)([
                                                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1"
                                            ]),
                                            children: productName
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_syaz9sh9 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _ect4bzd7 _1wybdlk8"
                                            ]),
                                            style: {
                                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                            },
                                            children: d0to6JiraSite.displayName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                    variant: "primary",
                                    size: "small",
                                    color: "blue",
                                    children: goToProductButtonText
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _k48pbfng _y3gn1h6o"
                ]),
                children: createNewWorkspaceMessage
            })
        ]
    });
};
const $255f9296a7acccf2$var$switchAccountLink = (children)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
        href: (0, $jgJpJ.getSwitchAccountUrl)(),
        className: (0, $esG4f.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la _o5721q9c _30l31ep1"
        ]),
        style: {
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: children
    });
const $255f9296a7acccf2$var$getProductUrl = ({ url: url, productKey: productKey })=>{
    switch(productKey){
        case (0, $jgJpJ.ProductKey).JIRA_SOFTWARE:
            return `${url}/jira`;
        case (0, $jgJpJ.ProductKey).CONFLUENCE:
            return `${url}/wiki`;
        default:
            return url;
    }
};
const $255f9296a7acccf2$var$containerCss = null;
const $255f9296a7acccf2$var$formContainerCss = null;
const $255f9296a7acccf2$var$headerGroupCss = null;
const $255f9296a7acccf2$var$headerCss = null;
const $255f9296a7acccf2$var$switchAccountSubheader = null;
const $255f9296a7acccf2$var$createNewWorkspaceMessageCss = null;
const $255f9296a7acccf2$var$createNewWorkspaceLinkCss = null;
const $255f9296a7acccf2$var$boxContainerCss = null;
const $255f9296a7acccf2$var$siteBoxCss = null;
const $255f9296a7acccf2$var$bold = null;
const $255f9296a7acccf2$var$siteCss = null;
const $255f9296a7acccf2$var$siteNameCss = null;
const $255f9296a7acccf2$var$emailCss = null;
const $255f9296a7acccf2$var$switchAccountLinkCss = null;

});






//# sourceMappingURL=confluence-software-anchor-lp-automation.dd5bd95a.js.map
